import { inject } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { GlobalSpsErrorHandler } from '@lib/utils/global-error-handler';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

export abstract class BaseEffects {
  protected actions$ = inject(Actions);
  protected errorHandler = inject(GlobalSpsErrorHandler);

  protected logError(error: HttpErrorResponse | string | Error): void {
    if (!environment.production) {
      console.warn(error);
    }

    const message = error['message'] || error;
    this.errorHandler.handleError(message);
  }
}
